let deviceInfo;
export default {
  /**
   * 风控获取指纹信息
   */
  getDeviceInfo() {
    if (deviceInfo && Object.keys(deviceInfo).length > 0) return deviceInfo;
    //天盾js获取到的设备信息与天盾接口入参映射表
    const mappingTable = {
      dt: "deviceType",
      ma: "macAddress",
      im: "imei",
      os: "os",
      osv: "osVersion",
      fp: "fp",
      ip: "ip",
      eid: "eid",
      apid: "appId",
      ou: "openUUID",
      ia: "idfa",
      uu: "uuid",
      cv: "clientVersion",
      nt: "networkType",
      at: "appType",
      sdkToken: "sdkToken",
      token: "token",
      jstub: "jstub",
      jsToken: "jsToken",
    };
    const riskParams = {};
    let riskJd = {};

    try {
      riskJd = window.getJdEid();
      console.log('riskJd',riskJd)
    } catch (e) {
      console.log(e);
    }
    Object.keys(riskJd).map((key) => {
      Object.assign(riskParams, {
        [mappingTable[key]]: riskJd[key],
      });
    });

    if (!this.isJDApp() && !this.isJRApp()) {
      riskParams.appType = this.getAt();
    }

    deviceInfo = riskParams;

    return riskParams;
  },

  /**
   * 获取环境参数
   */
  getAt() {
    let at = 6;
    if (this.isIOS()) {
      at = 1;
    } else if (this.isAndroid()) {
      at = 3;
    }
    return at;
  },
  isJRApp() {
    if (navigator && navigator.userAgent) {
      return /jdjr-app/i.test(navigator.userAgent);
    }
    return false;
  },
  isJDApp() {
    if (navigator && navigator.userAgent) {
      return /jdapp/i.test(navigator.userAgent);
    }
    return false;
  },
  isIOS() {
    var u = window.navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  },
  isAndroid() {
    var u = window.navigator.userAgent;
    return u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
  },
};
